export const fr = {
  'sidebar.start': 'Accueil',
  'sidebar.setup': 'Configuration',
  'sidebar.test01': 'Test01',
  'sidebar.test04': 'Test04',
  'sidebar.test05': 'Test05',
  'sidebar.test06': 'Test06',
  'sidebar.test07': 'Test07',
  'sidebar.live-chat': 'chat en direct',
  'sidebar.booking-confirmation': 'Confirmation',
  'sidebar.appointments': 'Rendez-vous',

  'appointments': 'rendez-vous',
  'documents': 'Documents',
  'start': 'accueil',
  'advice': 'guide et conseils',

  'dashboard': 'tableau de bord',
  'profile': 'profil',
  'contact': 'Contact',
  'logout': 'déconnexion',
  'login': 'connexion',
  'agenda': 'agenda',
  'single appointment': 'rendez-vous unique',
  'appointment chain': 'série de rendez-vous',
  'jan': 'janvier',
  'feb': 'fevrier',
  'mar': 'mars',
  'apr': 'avril',
  'may': 'mai',
  'jun': 'juin',
  'jul': 'juillet',
  'aug': 'aout',
  'sep': 'septembre',
  'oct': 'octobre',
  'nov': 'novembre',
  'dec': 'decembre',

  ':weg': 'Dentiste absent',
  ':room': 'Salle indisponible',
  ':instr': 'Instruments chirurgicaux déjà utilisés',
  ':scan': 'Scanner déjà utilisé',
  ':endo': 'Moteur endodontique déjà utilisé',
  ':cnc': 'Fraiseuse indisponible',
  ':opt': 'Appareil OPT/CBCT indisponible',

  'passwords_do_not_match': 'Les mots de passe ne correspondent pas',
  'user_already_registered': 'Utilisateur déjà enregistré. Veuillez vous connecter à la place.',
  'registration_failed': 'Échec de l\'inscription',
  'network_error': 'Erreur réseau',

  'swelling': 'Gonflement',
  'dental pain': 'Douleur dentaire',
  'bleeding': 'Saignement',
  'broken tooth': 'Dent cassée',
  'lost filling': 'Plombage perdu',
  'lost crown or bridge': 'Couronne ou bridge perdu',
  'problems after dental surgery': 'Problèmes après une chirurgie dentaire',
  'sensitivity to hot or cold': 'Sensibilité au chaud ou au froid',
  'braces or aligner emergency': "Urgence liée à l'appareil dentaire ou aux aligneurs",
  'left': 'gauche',
  'right': 'droite',
  'upper': 'Mâchoire supérieure',
  'lower': 'Mâchoire inférieure',

  "no-appointments-available": "Aucun rendez-vous",
  "chain-date-range-short-hover": "Le rendez-vous sélectionné fait partie d’une série de rendez-vous et doit avoir lieu entre le {from} et le {to}.",
  "chain-hover-text": "Termin-Serie",
};
